import React, { useEffect, useState } from 'react';
import { DidomiSDK } from '@didomi/react';
import { withRouter } from 'react-router-dom';

import { PATH } from '../../constants/path';
import { DIDOMI_NOTICE_ID, DIDOMI_PUBLIC_API_KEY } from '../../constants';

import gtm from '../../utils/gtmUtils';

const TrackingContext = React.createContext({ ready: false, gtm });

export const useTracking = (page, category) => {
    const context = React.useContext(TrackingContext);

    useEffect(() => {
        if (context.ready && page && category) {
            gtm.page(page, category);
        }
    }, [context.ready, page, category]);

    return context;
};

const triggerHistoryChange = pathname => {
    const paths = {
        [PATH.HOW_IT_WORK_PATH]: 'Comment ça marche ?',
        [PATH.FAQ_PATH]: 'Foire aux questions',
        [PATH.LEGAL_NOTICE_PATH]: 'Mentions Légales',
        [PATH.TERMS_PATH]: 'CGU',
        [PATH.TERMS_OF_SALES]: 'CGV',
        [PATH.CONTACTREQUEST_PATH]: 'Page de contact service client',
        [PATH.CASHBACK_EBON_MOST_POPULAR_PATH]: 'Annuaire offres ebon',
        [PATH.CASHBACK_EBON_ALPHA_PATH]: 'Annuaire alphabétique',
        [PATH.CASHBACK_EBON_CATEGORY_PATH]: 'Annuaire par catégorie',
        [PATH.MERCHANTPAGE_EBON_PATH]: 'Fiche marchand',
        [PATH.EBON_VALIDATION_PATH]: "Tunnel d'achat",
        [PATH.EBON_CONFIRMATION_PATH]: 'Confirmation de commande',
        [PATH.EBON_ERROR_PATH]: 'Erreur de commande',
        [PATH.EBON_DOWNLOAD_BILL_PATH]: 'Récupération de sa facture',
        [PATH.EBONS_REMINDER_PATH]: "Récupérer mes bons d'achats (renvoi de mails de confirmation)",
        [PATH.KYC_CONFIRMATION_PATH]: 'Etat du KYC (validé/refusé/retry)',
        [PATH.NOT_FOUND_PATH]: 'Page non trouvée'
    };

    const matchingPath = Object.entries(paths).find(([key]) => pathname.includes(key));
    const title = matchingPath ? matchingPath[1] : null;

    if (title) gtm.page(title);
};

const TrackingProvider = ({ children, location }) => {
    const [DOMReady, setDOMReady] = useState(false);
    const [didomiReady, setDidomiReady] = useState(false);

    useEffect(() => {
        setDOMReady(true);
    }, []);

    useEffect(() => {
        if (didomiReady && DOMReady && location.pathname) {
            triggerHistoryChange(location.pathname);
        }
    }, [didomiReady, DOMReady, location.pathname]);

    const value = {
        ready: DOMReady && didomiReady,
        gtm
    };

    return (
        <TrackingContext.Provider value={value}>
            {children}
            <DidomiSDK
                iabVersion={2}
                noticeId={DIDOMI_NOTICE_ID}
                apiKey={DIDOMI_PUBLIC_API_KEY}
                gdprAppliesGlobally
                sdkPath="https://sdk.privacy-center.org/"
                embedTCFStub
                onReady={() => setDidomiReady(true)}
            />
        </TrackingContext.Provider>
    );
};

export default withRouter(TrackingProvider);



// WEBPACK FOOTER //
// ./src/tracking/provider/index.jsx